import { jsx as _jsx } from "react/jsx-runtime";
import { ErrorMessage } from "formik";
export const CErrorMessage = ({ name, className = "", ...props }) => {
    return (_jsx("span", { className: `invalid-feedback form-error-message ${className}`, children: _jsx(ErrorMessage, { ...props, name: name, className: `invalid-feedback ${className}`, "data-valmsg-for": name, "data-valmsg-replace": "true" }) }));
};
